import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IAsset } from '../../pages/Wallet/types';
import { Wallet_Asset } from '../../generated/mlmbox/types/wallet';

export interface IOperationFeeProps {
    withDrawProcessingAlow: IAsset | null;
    userWallet?: Wallet_Asset;
    operationFeeFromBody: boolean;
    setOperationFeeFromBody: Function;
    amountValue: string;
}

const OperationFee: FC<IOperationFeeProps> = ({ withDrawProcessingAlow, setOperationFeeFromBody, amountValue, userWallet, operationFeeFromBody }) => {
    const [fee, setFee] = useState(0);
    const { t } = useTranslation();
    useEffect(() => {
        operationFeeFromBody &&
            setFee(
                Number(amountValue) -
                    (Number(amountValue) - Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase)) /
                        (Number(withDrawProcessingAlow?.settingsWithdrawalFeePercent) + 1)
            );

        !operationFeeFromBody && setFee(Number(amountValue) / 100 + Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase));
    }, [amountValue, operationFeeFromBody]);

    return (
        <>
            {userWallet && (
                <div className="operation-fee">
                    {Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase) + Number(withDrawProcessingAlow?.settingsWithdrawalFeePercent) ===
                    0 ? (
                        <p>{t('operationFee.title')} 0%</p>
                    ) : (
                        <p>
                            {t('operationFee.title')} {Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase)}$ +{' '}
                            {Number(withDrawProcessingAlow?.settingsWithdrawalFeePercent) * 100}%
                        </p>
                    )}

                    {Number(withDrawProcessingAlow?.settingsWithdrawalFeeBase) + Number(withDrawProcessingAlow?.settingsWithdrawalFeePercent) !==
                        0 && (
                        <div className="operation-fee__btns">
                            <button
                                className={operationFeeFromBody ? 'active' : ''}
                                onClick={() => setOperationFeeFromBody(true)}>
                                {t('operationFee.btns.body')}
                            </button>
                            <button
                                className={!operationFeeFromBody ? 'active' : ''}
                                onClick={() => setOperationFeeFromBody(false)}>
                                {t('operationFee.btns.balance')}
                            </button>
                        </div>
                    )}

                    {operationFeeFromBody && (
                        <div className="operation-fee__content">
                            <ul>
                                <li>
                                    {t('operationFee.options.option_1')}{' '}
                                    {Number(amountValue) !== 0
                                        ? Number(amountValue) - fee < 0
                                            ? Number(0).toFixed(2)
                                            : (Number(amountValue) - fee).toLocaleString()
                                        : 0}
                                </li>
                                <li>
                                    {t('operationFee.options.option_2')} {Number(amountValue) !== 0 ? Number(amountValue).toLocaleString() : 0}
                                </li>
                                <li>
                                    {t('operationFee.options.option_3')}{' '}
                                    {Number(amountValue) !== 0 ? (Number(userWallet.assetBalance) - Number(amountValue)).toLocaleString() : 0}
                                </li>
                            </ul>
                        </div>
                    )}
                    {!operationFeeFromBody && (
                        <div className="operation-fee__content">
                            <ul>
                                <li>
                                    {t('operationFee.options.option_1')} {Number(amountValue) !== 0 ? Number(amountValue).toLocaleString() : 0}
                                </li>
                                <li>
                                    {t('operationFee.options.option_2')}{' '}
                                    {Number(amountValue) !== 0 ? Math.abs(Number(amountValue) + fee).toLocaleString() : 0}
                                </li>
                                <li>
                                    {t('operationFee.options.option_3')}{' '}
                                    {Number(amountValue) !== 0 ? (Number(userWallet.assetBalance) - (Number(amountValue) + fee)).toLocaleString() : 0}
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default OperationFee;
